<template>
  <div class="login-wrap">
    <div class="card">
      <div class="brand">
        <div class="brand-mark">代</div>
        <div>
          <h2>代理商后台</h2>
          <p>使用平台分配的账号密码登录</p>
        </div>
      </div>
      <el-form :model="form" label-position="top" size="large" @submit.prevent>
        <el-form-item label="登录账号">
          <el-input v-model="form.username" placeholder="请输入登录账号" clearable />
        </el-form-item>
        <el-form-item label="登录密码">
          <el-input
            v-model="form.password"
            type="password"
            show-password
            placeholder="请输入登录密码"
            @keyup.enter="login"
          />
        </el-form-item>
        <el-button class="login-btn" type="primary" :loading="loading" @click="login">登录</el-button>
      </el-form>
      <div class="tip">账号密码由平台运营在「代理商管理」中设置</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { portalLogin, setAgentPortalToken } from '@/api/agent/portal'
import { getTenantIdByName } from '@/api/login'
import { setTenantId, getTenantId } from '@/utils/auth'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'

defineOptions({ name: 'AgentPortalLogin' })
const router = useRouter()
const form = reactive({ username: '', password: '' })
const loading = ref(false)

const ensureTenant = async () => {
  if (getTenantId()) return
  const name = import.meta.env.VITE_APP_DEFAULT_LOGIN_TENANT || '紫金山'
  try {
    const id = await getTenantIdByName(name)
    if (id != null) setTenantId(Number(id))
  } catch {}
}

const login = async () => {
  if (!form.username || !form.password) return ElMessage.warning('请填写账号和密码')
  loading.value = true
  try {
    await ensureTenant()
    const data = await portalLogin(form)
    setAgentPortalToken(data.token)
    localStorage.setItem('agent_portal_name', data.name || '')
    localStorage.setItem('agent_portal_id', String(data.agentId))
    localStorage.setItem('agent_portal_no', data.agentNo || '')
    localStorage.setItem('agent_portal_username', form.username)
    ElMessage.success('登录成功')
    router.replace('/agent-portal/workbench')
  } catch (e: any) {
    ElMessage.error(e?.message || '登录失败，请检查账号密码或联系平台运营')
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.login-wrap {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #062e2a 0%, #083a34 45%, #0e9c8d 100%);
}
.card {
  width: 420px;
  background: #fff;
  border-radius: 14px;
  padding: 32px 28px 24px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.22);
}
.brand {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 22px;
}
.brand-mark {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #0e9c8d, #14b8a6);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  flex-shrink: 0;
}
.card h2 {
  margin: 0 0 4px;
  font-size: 22px;
  color: #1f2937;
}
.card p {
  margin: 0;
  color: #909399;
  font-size: 13px;
}
.login-btn {
  width: 100%;
  background: #0e9c8d;
  border-color: #0e9c8d;
}
.login-btn:hover {
  background: #0b8578;
  border-color: #0b8578;
}
.tip {
  margin-top: 16px;
  text-align: center;
  font-size: 12px;
  color: #909399;
}
</style>
